// extracted by mini-css-extract-plugin
module.exports =  {"button":"TruncatedText-styles-button-f7577322"};